import { useMemo } from 'react';

import { HelperText } from '@bambi/component-library/src/components/forms/FormFieldHelperText/FormFieldHelperText';

import { serviceTypeOptions } from 'src/features/add-trip/ServiceDetails/serviceTypeOptions';

import { FormFieldControllerRulesProps } from './FormField/FormFieldController';
import { MultiSelectContextField } from './FormField/MultiSelectContextField';

export function MultiSelectServiceTypeField({
  fieldPath,
  rules,
  inline,
  placeholder,
  disabled,
  helperText,
}: {
  fieldPath: string;
  rules?: FormFieldControllerRulesProps;
  inline?: boolean;
  placeholder?: string;
  disabled?: boolean;
  helperText?: HelperText;
}) {
  const label = useMemo(() => {
    return rules?.required ? 'Service Types *' : 'Service Types';
  }, [rules?.required]);

  return (
    <MultiSelectContextField
      options={serviceTypeOptions}
      fieldPath={fieldPath}
      label={label}
      disabled={disabled}
      rules={rules}
      inline={inline}
      helperText={helperText}
      placeholder={placeholder}
    />
  );
}
